// extracted by mini-css-extract-plugin
module.exports = {"MarketplaceBreadcrumbs":"MarketplaceBreadcrumbs_MarketplaceBreadcrumbs__2P7ng"};